import Box from "@@/elements/Box";
import { CloseThin, SearchIcon } from "@@/elements/Icons/icons";
import cn from "classnames";
import { useRef } from "react";
import styles from "./styles.module.scss";

type Icon = "search";

type Props = {
  input: string;
  setInput: (arg: string) => void;
  onSubmit?: () => void;
  onReset?: () => void;
  onInputKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabledSubmit?: boolean;
  icon?: Icon;
  id?: string;
  ariaAutoComplete?: string;
  resetLabel?: string;
};

const TextInput = ({
  // TODO: Disabled text input state
  input, setInput, onSubmit, onReset, onInputKeyDown, placeholder, /* disabled */ disabledSubmit, icon, id,
  ariaAutoComplete, resetLabel,
}:Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onSubmit();
    }
    if (onInputKeyDown) {
      onInputKeyDown(e);
    }
  };

  const onResetClick = () => {
    if (onReset) onReset();
    else setInput("");
    inputRef.current?.focus();
  };

  const renderIcon = () => {
    switch (icon) {
    case "search":
      return <SearchIcon />;
    default:
      return <SearchIcon />;
    }
  };

  return (
    <Box
      className={styles.input_wrapper} 
      alignItems="center">
      {onSubmit && (
        <button
          type="submit"
          aria-label="search"
          className={cn(styles.button__search, styles.button)}
          onClick={!disabledSubmit ? () => onSubmit() : () => {}}
          disabled={disabledSubmit}
        >
          {renderIcon()}
        </button>
      )}
      <input
        ref={inputRef}
        placeholder={placeholder}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKeyDown}
        type="search"
        id={id}
        autoComplete="off"
        aria-autocomplete={ariaAutoComplete}
      />
      {!!input.length && (
        <button
          type="button"
          aria-label={resetLabel || "reset"}
          className={cn(styles.button__reset, styles.button)}
          onClick={onResetClick}
        >
          <CloseThin />
        </button>
      )}
    </Box>
  );
};

export default TextInput;
